import { render, staticRenderFns } from "./Rscs.vue?vue&type=template&id=0f348999"
import script from "./Rscs.vue?vue&type=script&lang=js"
export * from "./Rscs.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports